<template lang="pug">
    div
        BreadCrumb(:linkBreadCrumb='linkBreadCrumb')
        manager-wholesale-discounts(submitText="Crear esquema" crudOption="create"
            @clear-form="clearForm"
            @submit-form="submitForm"
            @cancel-editing="returnPreviousRoute"
            )
            div
                family-data
</template>

<script>
import { BreadCrumb } from '@/components/reusable_components'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import ManagerWholesaleDiscounts from '@/components/WholesaleDiscount/Manager'
import SnackbarModalUtils from '@/mixins/SnackbarModalUtils'
import FamilyData from './FamilyData'

import FamilyWholesaleDiscountService from '@/services/api/family/FamilyWholesaleDiscountService'
import { mapActions, mapState } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: false,
                    to: `/families`,
                    exact: true,
                },
                {
                    text: 'Familia',
                    disabled: false,
                    to: `/families/${this.$route.params.id}`,
                    exact: true,
                },
                {
                    text: 'Creación Esquema Descuentos',
                    disabled: true,
                },
            ],
        }
    },
    computed: {
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
            globalPercentageDiscount: 'globalPercentageDiscount',
        }),
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        ...mapActions('WholesaleDiscountModule', {
            resetArrayDiscounts: 'resetArrayDiscounts',
            addDiscount: 'addDiscount',
            resetStateWholesaleDiscount: 'resetState',
            setGlobalPercentageDiscount: 'setGlobalPercentageDiscount',
            setId: 'setId',
            setMaxPriceDiscount: 'setMaxPriceDiscount',
            restartEditing :'restartEditing',
        }),

        returnPreviousRoute() {
            this.$router.push({ path: `/families/${this.id}` })
        },

        clearForm() {
            this.resetArrayDiscounts()
        },

        async submitForm() {
            let snackLoading = this.fillSnack(
                'info',
                'Creando',
                'Espere un momento',
                true,
                6000
            )
            this.initSnackbar(snackLoading)
            let response = await FamilyWholesaleDiscountService.createWholeSaleDiscounts(
                this.arrayDiscounts,
                this.id
            )
            if (response.status == 'success') {
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'El esquema de descuentos se ha guardado exitosamente',
                    false,
                    6000
                )
                this.initSnackbar(snackInfo)
                this.$router.push({ path: `/families/${this.id}` })
            } else {
                //TODO: test response error from backend
                let snackInfo = this.fillSnack(
                    'error',
                    'Error',
                    response,
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
            }
        },
    },
    watch: {},
    components: { ManagerWholesaleDiscounts, FamilyData, BreadCrumb },
    mixins: [InputValidations, CurrencyUtils, SnackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: async function() {
        let id = this.$route.params.id
        let whDiscounts = await FamilyWholesaleDiscountService.fetchWholesaleDiscountsFamily(
            id
        )
        if (whDiscounts === null || whDiscounts.length === 0) {
            // Wholesale discounts should be created
            await this.resetStateWholesaleDiscount()
            this.setGlobalPercentageDiscount(true)
            this.addDiscount()
            this.setId(id)
            this.setMaxPriceDiscount(100)
            // this.setId(id)
            // this.setGlobalPercentageDiscount(true)
            // this.addDiscount()
        } else {
            // Wholesale discounts should be shown/edited
            this.$router.push({ path: `/families/${id}/wholesale_discounts` })
        }
    },
    mounted: function() {
        this.setTitleTopBar('Crear esquema descuentos familia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_WHOLESALE_DISCOUNT_BY_FAMILY')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>